var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('signature-form',{attrs:{"loading":_vm.loading,"signatureData":_vm.signature,"formErrors":_vm.formErrors},on:{"signatureSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }